import { render } from "./AuthView.vue?vue&type=template&id=6f7120ca"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__